module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc36-8d8656da952af5121e0f521a72920deb.jpg";